// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

const ReadPenerimaanBarangPage = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    PurchaseOrderID: "",
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [modalID, setModalID] = useState(0);
  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const params = useParams();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/GoodsAcceptance", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Procurement/GoodsAcceptance/one/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Procurement/GoodsAcceptance", formData)
  );
  const po = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/min/" + formData)
  );
  const detailPO = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/warehouse/" + formData)
  );
  const navigate = useNavigate();

  useEffect(() => {
    po.mutate(values.BisnisUnitID);
  }, [values.BisnisUnitID]);

  useEffect(() => {
    detailPO.mutate(values.PurchaseOrderID);
  }, [values.PurchaseOrderID]);

  useEffect(() => {
    if (values.PurchaseOrderID !== "" && detailPO.data) {
      if (!params.transid) setDetail(detailPO.data.data);
    }
  }, [detailPO.data]);

  useEffect(() => {
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid.replaceAll("-", "/"));
    }

    if (params.id) {
      customHandler(params.id, "BisnisUnitID");
    }
  }, []);

  useEffect(() => {
    if (values.PurchaseOrderID !== "" && detailPO.data) {
      if (!params.transid) setDetail(detailPO.data.data);
    }
  }, [detailPO.data]);

  useEffect(() => {
    if (mutationGet.data) {
      let temp = mutationGet.data.data;
      temp["BisnisUnitID"] = params.id;

      setDetail(temp["Data"]);
      blastChange(mutationGet.data.data);
    }
  }, [mutationGet.status]);

  const header = [
    { name: "Nama Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Spec", key: "Spec", modifiers: "Text" },
    { name: "Satuan", key: "BarangID", modifiers: "BarangSatuan" },
    { name: "Jumlah Pesanan (PO)", key: "Qty", modifiers: "number" },
    { name: "Jumlah di Terima", key: "QtyMasuk", modifiers: "number" },
    { name: "Jumlah Belum di Terima", key: "QtyBelum", modifiers: "QtyBelumColor" },
    { name: "Keterangan", key: "KeteranganDetail", modifiers: "Text" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  // Koreksi otomatis kolom Keterangan (khusus tampilan halaman detail ini, tidak
  // mengubah data tersimpan): "Sesuai" bila sisa belum diterima <= 0, selain itu
  // "Kurang N". Diturunkan dari QtyBelum (kumulatif) agar konsisten dengan kolom
  // "Jumlah Belum di Terima". Bila QtyBelum tidak ada, pakai keterangan asli.
  const detailView = (detail || []).map((item) => {
    const sisa = parseFloat(item?.QtyBelum);
    if (isNaN(sisa)) return item;
    return {
      ...item,
      KeteranganDetail: sisa <= 0 ? "Sesuai" : `Kurang ${sisa}`,
    };
  });

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/gudang/penerimaan/")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                </div>

                {values["BisnisUnitID"] && (
                  <>
                    {po.data && po.data.data !== null ? (
                      <div className="w-1/3">
                        <div className={"w-full px-3 mb-6"}>
                          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            No. Purchase Order *
                          </label>
                          <Select
                            value={po.data.data.filter(
                              ({ value }) => value === values["PurchaseOrderID"]
                            )}
                            isDisabled={true}
                            name={"PurchaseOrderID"}
                            className={
                              (touched["PurchaseOrderID"] || buttonTouched) &&
                              errors["PurchaseOrderID"]
                                ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                                : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                            }
                            onChange={(text) =>
                              customHandler(text.value, "PurchaseOrderID")
                            }
                            options={po.data.data}
                          />

                          {(touched["PurchaseOrderID"] || buttonTouched) &&
                            touched["PurchaseOrderID"] && (
                              <p className="text-red-500 text-xs italic">
                                {errors["PurchaseOrderID"]}
                              </p>
                            )}
                        </div>
                      </div>
                    ) : (
                      <div className={"w-full px-3 mb-6 text-red-800"}>
                        "Tidak ada PO"{" "}
                      </div>
                    )}
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"dateOnly"}
                        value={values}
                        name={"Tanggal"}
                        title={"Tanggal Terima Barang"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"NamaPenerima"}
                        title={"Nama Penerima"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                    </div>
                    <div className="w-1/3">
                      <HrdInputGenerator
                        type={"LokasiGudang"}
                        value={values}
                        name={"LokasiGudang"}
                        title={"Lokasi Gudang"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                    </div>
                    <div className="w-1/2">
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"Keterangan"}
                        title={"Keterangan"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={true}
                      />
                    </div>
                  </>
                )}

                <hr />
                <DynamicTableSimple
                  data={detailView}
                  header={header}
                  Master={false}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReadPenerimaanBarangPage;
